import { observer } from 'mobx-react';
import * as React from 'react';
import { toast, ToastContainer } from 'react-toastify';

import { WithDbId } from '../../../../../adl-gen/common/db';
import { Question, WorkRole } from '../../../../../adl-gen/totalinteraction/futurefit/db';
import { RepositoryEntrySet } from '../../../../../adl-gen/totalinteraction/futurefit/frontend';
import { CreateQuizReq } from '../../../../../adl-gen/totalinteraction/futurefit/requests';
import { withI18n, WithI18nProps } from '../../../../../internationalization/i18n-hoc';
import { QuizAdminStore } from '../../../../stores';
import { FormMode, toastOptions } from '../../../common/form';
import { QuizEditor } from '../../editors/quiz-editor/quiz-editor';

// const styles = require("../../../common/editor.css")

/** Quiz-generation props definitions */
interface QuizAdminFormProps extends WithI18nProps {
  workrole: WithDbId<WorkRole>;
  repository: RepositoryEntrySet;
  nonSkillQuestions: WithDbId<Question>[];

  store: QuizAdminStore;

  mode?: FormMode;
  onCancel?(): void;
}

@observer
class QuizAdminForm0 extends React.Component<QuizAdminFormProps> {
  onCancel = () => {
    if (this.props.onCancel) {
      this.props.onCancel();
    }
  };

  onCreate = async (item: CreateQuizReq): Promise<void> => {
    // if (!this.props.store.isSuperUser) {
    //   throw new Error("cannot generate quiz - not authorized")
    // } else {
    const toastId = toast.loading('Please wait...', { ...toastOptions, autoClose: 3000 });
    try {
      await this.props.store.createQuiz(item);

      toast.dismiss(toastId);
      toast.success(`Quiz ${item.title.value.en} generated.`, {
        ...toastOptions,
        onClose: this.onCancel,
        autoClose: 3000
      });
    } catch (e) {
      toast.dismiss(toastId);
      toast.error(`Quiz ${item.title.value.en} generation failed: ${(e as Error).message}`, {
        ...toastOptions,
        onClose: this.onCancel
      });
    }
    // }
  };

  renderContent = () => {
    const {
      nonSkillQuestions,
      repository,
      workrole,
      // mode,
      store
      // toDelete,
    } = this.props;
    /// TODO: Update/Delete. Leaving mode in here for future use
    // if (mode === "create"|undefined)
    return (
      <QuizEditor
        workrole={workrole}
        repository={repository}
        nonSkillQuestions={nonSkillQuestions}
        onUpload={store.uploadRepositoryEntry}
        onCancel={this.onCancel}
        onCreate={this.onCreate}
        role={store.isSuperUser ? 'super' : 'client-admin'}
      />
    );
  };

  render() {
    return (
      <React.Fragment>
        <ToastContainer newestOnTop />
        {this.renderContent()}
      </React.Fragment>
    );
  }
}

export const QuizAdminForm = withI18n(QuizAdminForm0);



// WEBPACK FOOTER //
// ./src/admin/ui/components/forms/quiz-admin-form/quiz-admin-form.tsx